﻿import {Core} from "../Base/Core";
import {EpochListItem} from "./EpochListItem";
import {GameManager} from "../Game/GameManager";
import {UIBase} from "./Tools/Base/UIBase";
import {UINineSlice} from "./Tools/Base/UINineSlice";

export class EpochsList extends UIBase {

    Awake() {
        super.Awake();
        this.back = this.addChild(new UINineSlice("bg-rounding-60px"));
        this.back.tint = 0x000000;
        this.back.alpha = 0.3;

        this.items = [];
        this._rect = new PIXI.Rectangle;
    }

    Init() {
        this.onPlayerChanged = this.onPlayerChanged.bind(this);
        this.onEpochSelected = this.onEpochSelected.bind(this);

        this.items = [];
        for (let e of Core.GameData.Epochs.epochs) {
            this.items.unshift(this.addChild(new EpochListItem(e)));
        }

        Core.Player.on("Changed", this.onPlayerChanged);
        Core.Player.PlanetsSave.on("EpochUnlocked", (epochId) => {
            this.OpenEpoch(epochId);
        });
        GameManager.on("EpochSelected", this.onEpochSelected);
    }

    fitLayout(buttonRect = this._rect) {
        this._rect.copyFrom(buttonRect);
        this.position.copyFrom(buttonRect);

        let items = this.items.filter(item => item.Active);

        let itemSize = buttonRect.width * 0.9;
        let paddingY = itemSize * 0.15;

        let itemRect = new PIXI.Rectangle((buttonRect.width - itemSize) * 0.5, paddingY, itemSize, itemSize);
        for (let item of items) {
            item.fitLayout(itemRect);
            itemRect.y += itemSize + paddingY;
        }

        this.back.width = buttonRect.width;
        this.back.height = (itemSize + paddingY) * items.length + paddingY;
    }

    GetItem(epochId) {
        for (let item of this.items) {
            if (item.epoch.id == epochId) return item;
        }
        return null;
    }

    OpenEpoch(epochId) {
        GameManager.gameView.SelectEpoch(epochId, true, 0);
    }

    onEpochSelected(epochId) {
        this.Update();
    }

    OnEnable() {
        this.onPlayerChanged();
    }

    onPlayerChanged() {
        if (!Core.Player.Initialized) return;
        this.Update();
        this.fitLayout();
    }

    Update() {
        for (let item of this.items) {
            item.Update();
        }
    }
}
